import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "DotsHolder"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("a", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-ellipsis-h" })
], -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = ["aria-label"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("li", {
    class: _normalizeClass({ 'active': _ctx.isActive })
  }, [
    (_ctx.page === null)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, _hoisted_3))
      : (_openBlock(), _createElementBlock("a", {
          key: 1,
          type: "button",
          "aria-label": `Go to page ${_ctx.page}`,
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clickHandler && _ctx.clickHandler(...args)))
        }, _toDisplayString(_ctx.page), 9, _hoisted_4))
  ], 2))
}